import { useAuth } from "@/contexts/auth/useAuth";

function useLoggedIn() {
  const { currentAccount } = useAuth();

  return {
    isLoggedIn: !!currentAccount,
  };
}

export { useLoggedIn };
